module.exports = __webpack_public_path__ + "static/media/modal-cedula.05860a82.png";